<template>
  <div class="game-input-on-background-wrapper">
    <div
      v-for="(image, index) in imageData"
      :key="index"
      class="main-image-container"
      :style="getImageStyle(image)"
    ></div>
    <div
      class="text-element"
      v-for="(item, index) in staticText"
      :key="'text_' + index"
      :style="getStaticTextStyle(item)"
      v-html="item.text"
    ></div>
    <tr-box
      v-if="words.length"
      :items="words"
      :config="boxConfig"
      :font-size="boxConfigFontSize"
      :style="getBoxStyle(startGameConfig.boxConfig)"
      class="box-style"
    >
    </tr-box>
    <tr-input
      v-for="(item, index) in items"
      :key="item.id"
      :config="item"
      :tr-input-value="inputData[index]"
      :input-width="item.inputWidth || startGameConfig.inputWidth"
      :input-height="item.inputHeight || startGameConfig.inputHeight"
      :input-font-size="item.inputFontSize || startGameConfig.inputFontSize"
      :max-length="item.inputMaxLength || startGameConfig.inputMaxLength"
    >
    </tr-input>
  </div>
</template>

<script>
import _ from 'lodash';
import TrInput from '../TrInput/TrInputV2';
import TrBox from '../../GameBaseElements/TrBox/TrBoxV2';
import * as utils from '../../Utils/inputUtilsV2';
import defaultMixin from '../../mixins/defaultMixinV2';
import inputMixin from '../../mixins/inputMixinV2';
export default {
  name: 'tr-input-on-background-v2',
  components: {
    TrInput,
    TrBox,
  },
  mixins: [inputMixin, defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      words: [],
      boxConfig: {
        x: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.left) || 1,
        y: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.top) || 14,
        width: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.width) || 98,
        height: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.height) || 12,
        unit: '%',
      },
      inputData: [],
      staticText: [],
      imageData: [],
    };
  },
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.items = this.prepareData(this.startGameConfig.items);
      this.inputData = _.map(this.items, (item) => {
        return {
          correct: item.correct,
          val: item.value || '',
          block: item.block || false,
          inputStatus: item.inputStatus || null,
          caseSensitive: item.caseSensitive || this.caseSensitive,
          coupled: item.coupled,
        };
      });
      this.longestWordLength = _.maxBy(this.inputData, (item) => {
        if (item.correct && _.isArray(item.correct)) {
          return item.correct.length;
        }
        return false;
      });
    },
    prepareData() {
      let selectedItem = {};
      let staticText = [];
      if (this.startGameConfig.pick > 1) {
        selectedItem = _.sampleSize(_.cloneDeep(this.startGameConfig.items), this.startGameConfig.pick);
        // COMBAK: add merge options
      } else if (this.startGameConfig.pick === 1 && _.isArray(this.startGameConfig.items)) {
        selectedItem = _.sample(_.cloneDeep(this.startGameConfig.items));
      } else if (
        this.startGameConfig.items &&
        !_.isArray(this.startGameConfig.items) &&
        this.startGameConfig.items.picks
      ) {
        selectedItem = this.startGameConfig.items;
      } else {
        selectedItem = this.startGameConfig;
      }
      if (selectedItem.pick && selectedItem.pick > 1) {
        this.items = _.sampleSize(_.cloneDeep(selectedItem.items), selectedItem.pick);
      } else if (selectedItem.pick && selectedItem.pick === 1) {
        this.items = _.sampleSize(_.cloneDeep(selectedItem.items), 1);
        if (this.items[0].items && this.items[0].items.length > 0) {
          this.items = this.items[0].items;
          selectedItem = this.items[0];
        }
      } else if (_.isArray(selectedItem.items)) {
        this.items = selectedItem.items;
      } else if (_.isObject(selectedItem)) {
        let counter = 0;
        this.items = _.flattenDeep(
          _.map(_.omit(selectedItem, ['picks']), (element) => {
            if (_.isArray(element) && selectedItem.picks && selectedItem.picks[counter]) {
              return _.flattenDeep(
                _.map(_.sampleSize(_.cloneDeep(element), selectedItem.picks[counter++]), (elem) => {
                  return [...elem.items];
                })
              );
            } else if (_.isArray(element)) {
              return [...element.items];
            }
          })
        );
      } else {
        this.items = _.flattenDeep(
          _.map(selectedItem, (item) => {
            if (item.items) {
              return _.flattenDeep([...item.items]);
            }
          })
        );
      }
      /**
       * remove undefined and other trash
       */
      this.items = _.compact(this.items);
      if (_.isArray(selectedItem.items) && selectedItem.items[0] && _.isArray(selectedItem.items[0].items)) {
        if (selectedItem.items[0].items[0] && selectedItem.items[0].items[0].imageData) {
          _.each(selectedItem.items[0].items, (elem) => {
            if (elem.imageData) {
              this.imageData.push(elem.imageData);
            }
          });
        } else if (selectedItem.items[0].imageData) {
          this.imageData.push(selectedItem.items[0].imageData);
        }
        if (this.startGameConfig.mainImage) {
          this.imageData.unshift(this.startGameConfig.mainImage);
        }
      } else if (selectedItem.imageData) {
        this.imageData = [selectedItem.imageData];
      } else if (this.startGameConfig.mainImage) {
        this.imageData = [this.startGameConfig.mainImage];
      } else if (this.startGameConfig.background) {
        this.imageData = [Object.assign({}, { imagePath: this.startGameConfig.background })];
      }
      if (this.startGameConfig.staticText) {
        staticText = staticText.length === 0 ? this.startGameConfig.staticText : staticText;
      }
      if (this.items && this.items[0] && this.items[0].staticText) {
        let itemsStaticText = _.map(this.items, (item) => {
          return item.staticText;
        });
        if (staticText.length > 0) {
          staticText = [...staticText, ...itemsStaticText];
        } else {
          staticText = itemsStaticText;
        }
      }
      if (staticText.length > 0) {
        this.staticText = _.map(staticText, (item, index) => {
          if (this.startGameConfig.layoutStaticText) {
            return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
          } else {
            return item;
          }
        });
      }
      this.items = selectedItem.shuffle ? _.shuffle(_.cloneDeep(this.items)) : this.items;
      /**
       * add layout if exist
       * @method if
       * @param  {array} this layoutItems array
       * @return {Boolean}
       */
      if (this.startGameConfig.layoutItems) {
        this.items = _.map(_.cloneDeep(this.items), (item, index) => {
          return Object.assign(item, this.startGameConfig.layoutItems[index]);
          // return _.merge( item, this.startGameConfig.layoutItems[ index ] );
        });
      }
      /**
       * box  text aplay
       * @type {[type]}
       */
      if (this.startGameConfig.words) {
        let syncData = this.startGameConfig.boxConfig.syncData;
        this.words = this.startGameConfig.words;
        if (this.startGameConfig.boxConfig && syncData) {
          this.words = _.intersection(
            this.startGameConfig.words,
            _.flattenDeep(
              _.map(this.items, (item) => {
                if (item[syncData]) {
                  return [...item[syncData]];
                } else if (item.markers) {
                  return _.flattenDeep(
                    _.map(item.markers, (item) => {
                      return [...item[syncData]];
                    })
                  );
                }
                return [...item[syncData]];
              })
            )
          );
        }
        this.words = _.shuffle(this.words);
      }
      return _.map(this.items, (item, key) => {
        if (key != 'pick' || key != 'shuffle') {
          return item;
        }
      });
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      this.init();
      // this.questionsList = this.processQuestionsList();
    },
    checkGameAction() {
      return this.inputOnBackgroundCheckGameAction();
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge({ position: 'absolute' }, this.getCustomStyle(imageData), {
        // 'position': 'absolute',
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      });
    },
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        // 'position': 'absolute',
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    getBoxStyle(box) {
      box.x = box.x;
      box.y = box.y;
      box.width = box.width;
      box.height = box.height;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(box), {
        // 'position': 'absolute',
        left: utils.elementLeftPosition(box.x, 0, '%'),
        top: utils.elementTopPosition(box.y, 0, '%'),
        width: utils.elementWidth(box.width, '%'),
        height: utils.elementHeight(box.height, '%'),
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    caseSensitive() {
      return this.startGameConfig.caseSensitive;
    },
    maxCharNumber() {
      return _.round((this.longestWordLength.correct.length * 120) / 100).toString();
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
    boxConfigFontSize() {
      let fontSize = this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.fontSize;
      return fontSize + 'px';
    },
  },
};
</script>

<style lang="scss" scoped>
.game-input-on-background-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  position: inherit;
  // background-image: url("~@/assets/icons/book/toolbox/przybornik_kosz.png");
  .main-image-container {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;

    background-size: contain;
    background-repeat: no-repeat;
  }
}
</style>
